import { Component, OnInit } from '@angular/core';
import { IndexView } from '@app/modules/common/views';
import { EmployeeModuleMenuService } from '@app/modules/employees/services/employee-module-menu.service';
import { CandidatesIndexTable } from '@app/modules/offer-letter/services/tables/candidates/candidate-index.table';
import { OfferLetterCreationReferer } from '@app/modules/offer-letter/types/offer-letter-referer-view.type';
import { AuthService } from '@app/services';

const referer: OfferLetterCreationReferer = 'candidate-index';

@Component({
    templateUrl: './candidate-index.template.html',
})
export class CandidateIndexView extends IndexView implements OnInit {
    queryParams = { referer } as const;
    table: CandidatesIndexTable;

    constructor(
        public employeeModuleMenuService: EmployeeModuleMenuService,
        private auth: AuthService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.table = new CandidatesIndexTable(this.auth);
    }
}
